var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNearby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nearby"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 44,
    fill: "#d1e7ff",
    rx: 30,
    ry: 18
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 44,
    fill: "#a2d0ff",
    rx: 20,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.11 45.06c-.44-2.24 0-6.46 7.76-9.6a2 2 0 0 1 1.5 3.7c-3.68 1.49-5.67 3.41-5.33 5.13.52 2.71 6.6 6.71 17.96 6.71s17.45-4 18-6.68c.34-1.74-1.66-3.66-5.34-5.16a2 2 0 1 1 1.5-3.7c8.07 3.27 8.12 7.82 7.77 9.62-2.61 13.21-41.23 13.25-43.82-.02z",
    fill: "#2e58ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 64c-31.8 0-43.28-25.22-18.82-36.22a2 2 0 0 1 1.64 3.64c-6.82 3.05-10.82 7.75-10.82 12.58 0 8.67 12.82 16 28 16s28-7.33 28-16c0-4.83-4-9.53-10.82-12.58a2 2 0 0 1 1.64-3.64c24.57 11.05 12.79 36.22-18.82 36.22z",
    fill: "#2e58ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 43h-8v-11l-6-2v-10a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v10l-6 2z",
    fill: "#8bc4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    fill: "#8bc4ff",
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.64 12.46a8 8 0 1 0 -13.28 0 8 8 0 0 0 -5.36 7.54v10a2 2 0 0 0 1.37 1.9l4.63 1.54v9.56a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-9.56l4.63-1.54a2 2 0 0 0 1.37-1.9v-10a8 8 0 0 0 -5.36-7.54zm-6.64-8.46a4 4 0 1 1 -4 4 4 4 0 0 1 4-4zm8 24.56-4.63 1.54a2 2 0 0 0 -1.37 1.9v9h-4v-9a2 2 0 0 0 -1.37-1.9l-4.63-1.54v-8.56a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4z",
    fill: "#2e58ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearby);
export default __webpack_public_path__ + "static/media/nearby.a50eb28b0875a4abccde1ef483a24f65.svg";
export { ForwardRef as ReactComponent };